import React from 'react';
import styled from 'styled-components';
import { bellOutline } from '@amzn/storm-ui-icons';
import { Flex, Icon } from '@amzn/storm-ui';

export type BellProps = {
  showBadge: boolean;
};

const StyledWrapper = styled(Flex)`
  position: relative;
  width: 100%;
  height: 100%;
`;

const StyledBadge = styled(Icon)`
  color: ${({ theme }) => theme.color.red[600]};
  position: absolute;
  top: 0;
  inset-inline-end: 1px;
`;

export const Bell: React.VFC<BellProps> = ({ showBadge }) => {
  return (
    <StyledWrapper alignItems="center" justifyContent="center">
      <Icon type={bellOutline} size="xlarge" />
      {showBadge && <StyledBadge type="circle" />}
    </StyledWrapper>
  );
};
